webpackJsonp([70144966829960],{

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(67);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactHelmet = __webpack_require__(65);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _NetlifyContactForm = __webpack_require__(279);
	
	var _NetlifyContactForm2 = _interopRequireDefault(_NetlifyContactForm);
	
	var _FooterCC = __webpack_require__(78);
	
	var _FooterCC2 = _interopRequireDefault(_FooterCC);
	
	var _HeaderCC = __webpack_require__(91);
	
	var _HeaderCC2 = _interopRequireDefault(_HeaderCC);
	
	var _reactIframe = __webpack_require__(66);
	
	var _reactIframe2 = _interopRequireDefault(_reactIframe);
	
	var _Split = __webpack_require__(44);
	
	var _Split2 = _interopRequireDefault(_Split);
	
	var _App = __webpack_require__(36);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Sidebar = __webpack_require__(59);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _LoginForm = __webpack_require__(55);
	
	var _LoginForm2 = _interopRequireDefault(_LoginForm);
	
	var _Article = __webpack_require__(37);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	var _Section = __webpack_require__(42);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Heading = __webpack_require__(16);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _Paragraph = __webpack_require__(24);
	
	var _Paragraph2 = _interopRequireDefault(_Paragraph);
	
	var _Footer = __webpack_require__(38);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Grommet = __webpack_require__(63);
	
	var _Grommet2 = _interopRequireDefault(_Grommet);
	
	var _Header = __webpack_require__(53);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Title = __webpack_require__(61);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Menu = __webpack_require__(41);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Anchor = __webpack_require__(27);
	
	var _Anchor2 = _interopRequireDefault(_Anchor);
	
	var _Box = __webpack_require__(8);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _Quote = __webpack_require__(57);
	
	var _Quote2 = _interopRequireDefault(_Quote);
	
	var _Card = __webpack_require__(51);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Columns = __webpack_require__(52);
	
	var _Columns2 = _interopRequireDefault(_Columns);
	
	var _Image = __webpack_require__(40);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Headline = __webpack_require__(39);
	
	var _Headline2 = _interopRequireDefault(_Headline);
	
	var _Button = __webpack_require__(14);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SocialFacebook = __webpack_require__(45);
	
	var _SocialFacebook2 = _interopRequireDefault(_SocialFacebook);
	
	var _LinkNext = __webpack_require__(28);
	
	var _LinkNext2 = _interopRequireDefault(_LinkNext);
	
	var _Hero = __webpack_require__(54);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _Form = __webpack_require__(30);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormField = __webpack_require__(31);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	var _TextInput = __webpack_require__(60);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _NumberInput = __webpack_require__(56);
	
	var _NumberInput2 = _interopRequireDefault(_NumberInput);
	
	var _SVGIcon = __webpack_require__(58);
	
	var _SVGIcon2 = _interopRequireDefault(_SVGIcon);
	
	var _Toast = __webpack_require__(62);
	
	var _Toast2 = _interopRequireDefault(_Toast);
	
	var _SocialShare = __webpack_require__(43);
	
	var _SocialShare2 = _interopRequireDefault(_SocialShare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Customers = function (_React$PureComponent) {
	  _inherits(Customers, _React$PureComponent);
	
	  function Customers() {
	    _classCallCheck(this, Customers);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  Customers.prototype.render = function render() {
	    return _react2.default.createElement(
	      _App2.default,
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Contact Us - Clean Clothes'
	        )
	      ),
	      _react2.default.createElement(_HeaderCC2.default, null),
	      _react2.default.createElement(
	        _Hero2.default,
	        { background: _react2.default.createElement(_Image2.default, { src: '/washer-unstyled.jpg',
	            fit: 'cover',
	            full: true }),
	          backgroundColorIndex: 'dark' },
	        _react2.default.createElement(
	          _Box2.default,
	          { direction: 'row',
	            justify: 'center',
	            align: 'center' },
	          _react2.default.createElement(_Box2.default, { basis: '1/2',
	            align: 'end',
	            pad: 'medium' }),
	          _react2.default.createElement(
	            _Box2.default,
	            { basis: '1/2',
	              align: 'start',
	              pad: 'medium' },
	            _react2.default.createElement(
	              _Box2.default,
	              { colorIndex: 'grey-2-a' },
	              _react2.default.createElement(_Card2.default, { heading: 'Get Involved',
	                description: 'Contact Us' })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _Box2.default,
	        { pad: 'large' },
	        _react2.default.createElement(
	          _Split2.default,
	          { fixed: false, showOnResponsive: 'both' },
	          _react2.default.createElement(
	            _Box2.default,
	            { colorIndex: 'light-2',
	              justify: 'center',
	              pad: 'medium',
	              textAlign: 'left' },
	            _react2.default.createElement(
	              _Heading2.default,
	              { tag: 'h3' },
	              'Location:'
	            ),
	            _react2.default.createElement(
	              _Anchor2.default,
	              { href: 'https://www.google.com/maps/place/Dutch+Girl+Coin+Laundry/@35.5610088,-82.5942075,13z/data=!4m8!1m2!2m1!1sdutch+girl+coin+laundry+asheville+nc!3m4!1s0x0:0xbe6e45b67a0b3599!8m2!3d35.5805465!4d-82.5971031' },
	              _react2.default.createElement(
	                _Heading2.default,
	                { tag: 'h4' },
	                'Dutch Girl Coin Laundry'
	              )
	            ),
	            _react2.default.createElement(
	              _Paragraph2.default,
	              null,
	              'Our volunteers meet Wednesday nights 5 pm \u2013 8 pm at Dutch Girl on Haywood Rd in West Asheville. There, they not only support the homeless, they also get a chance to interact with them, and build a bridge. Do you feel called to help those in need? Join us in this unique opportunity to serve the dignity of those who are often forgotten by volunteering.'
	            ),
	            _react2.default.createElement(
	              _Paragraph2.default,
	              null,
	              'Phone: ',
	              _react2.default.createElement(
	                _Anchor2.default,
	                { href: 'tel:1-828-367-7538' },
	                '(828) 367-7538'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Box2.default,
	            { colorIndex: 'light',
	              justify: 'center',
	              align: 'center',
	              pad: 'medium' },
	            _react2.default.createElement(_NetlifyContactForm2.default, null)
	          )
	        )
	      ),
	      _react2.default.createElement(_FooterCC2.default, null)
	    );
	  };
	
	  return Customers;
	}(_react2.default.PureComponent);
	
	exports.default = Customers;
	module.exports = exports['default'];

/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Contact = __webpack_require__(273);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Contact).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(189);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(65);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Heading = __webpack_require__(16);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _Box = __webpack_require__(8);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function encode(data) {
	  return Object.keys(data).map(function (key) {
	    return encodeURIComponent(key) + "=" + encodeURIComponent(data[key]);
	  }).join("&");
	}
	
	var NetlifyContactForm = function (_React$Component) {
	  _inherits(NetlifyContactForm, _React$Component);
	
	  function NetlifyContactForm(props) {
	    _classCallCheck(this, NetlifyContactForm);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.handleChange = function (e) {
	      var _this$setState;
	
	      _this.setState((_this$setState = {}, _this$setState[e.target.name] = e.target.value, _this$setState));
	    };
	
	    _this.handleSubmit = function (e) {
	      fetch("/", {
	        method: "POST",
	        headers: { "Content-Type": "application/x-www-form-urlencoded" },
	        body: encode(_extends({ "form-name": "newsletter" }, _this.state))
	      }).then(function () {
	        return alert("Success!");
	      }).catch(function (error) {
	        return alert(error);
	      });
	
	      e.preventDefault();
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  NetlifyContactForm.prototype.render = function render() {
	    return _react2.default.createElement(
	      _Box2.default,
	      null,
	      _react2.default.createElement(
	        "form",
	        {
	          name: "contact",
	          method: "post",
	          action: "/thanks/",
	          "data-netlify": "true",
	          "data-netlify-honeypot": "bot-field",
	          onSubmit: this.handleSubmit
	        },
	        _react2.default.createElement(
	          _Heading2.default,
	          { tag: "h3" },
	          "Contact Us:"
	        ),
	        _react2.default.createElement(
	          "p",
	          { hidden: true },
	          _react2.default.createElement(
	            "label",
	            null,
	            "Don\u2019t fill this out: ",
	            _react2.default.createElement("input", { name: "bot-field" })
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          _react2.default.createElement(
	            "label",
	            null,
	            _react2.default.createElement("input", { type: "text", name: "name", onChange: this.handleChange, placeholder: "Your Name" })
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          _react2.default.createElement(
	            "label",
	            null,
	            _react2.default.createElement("input", { type: "email", name: "email", onChange: this.handleChange, placeholder: "Your Email" })
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          _react2.default.createElement(
	            "label",
	            null,
	            _react2.default.createElement("textarea", { name: "message", onChange: this.handleChange, placeholder: "Message" })
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          _react2.default.createElement(
	            "button",
	            { type: "submit" },
	            "Send"
	          )
	        )
	      )
	    );
	  };
	
	  return NetlifyContactForm;
	}(_react2.default.Component);
	
	exports.default = NetlifyContactForm;
	module.exports = exports["default"];

/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Contact = __webpack_require__(274);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_React$Component) {
	  _inherits(Index, _React$Component);
	
	  function Index() {
	    _classCallCheck(this, Index);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Index.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_Contact2.default, null)
	    );
	  };
	
	  return Index;
	}(_react2.default.Component);
	
	exports.default = Index;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-3f31d01f53c5d63602ee.js